//const url_api = "https://localhost:44338/api/cuentas"
//----URL DEPLOY NETLIFY

import REACT_APP_API_URL from '../assets/images/imagenes/UrlApi'
const url_api=REACT_APP_API_URL+"/api/cuentas"


//-----URL LOCAL
//const url_api="http://localhost:26220/api/cuentas"

//-----URL DEPLOY
//const url_api="http://localhost/apivehiculos/api/cuentas"



export var LoginApi = async function (
  correo,
  password
) {


  return fetch(url_api + "/login", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    mode: 'cors',
    body: JSON.stringify({
      correo: correo,
      password: password,
    }),
  });
};


//---funcion para obtener valores del usuario
export async function PerfilUsuarioApi(cui) {
  // let usuarioActual = await JSON.parse(sessionStorage.getItem("usuarioActual"));
// console.log("llamando a perfil usuario api")
  let user = await JSON.parse(sessionStorage.getItem('usuario'));
  let token=null;
  if (user != null) {
    token = user.token;
  }
  //console.log("hola jeje")
  //console.log("el token en api perfil es " + token)

  return fetch(url_api + "/perfil/" + cui, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      'Authorization': `Bearer ${token}`
    },
    mode: 'cors'
  });
}


//---funcion para recuperar contraseña
export async function RecuperarPasswordApi(correo) {


  return fetch(url_api + "/RecuperarPassword", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    mode: 'cors',
    body: JSON.stringify({
      correo: correo
    }),
  });


}


//----funcion para obtener todos los usuarios
export async function GetUsuariosApi() {
  // let usuarioActual = await JSON.parse(sessionStorage.getItem("usuarioActual"));
  // console.log("llamando a perfil usuario api")
  let user = await JSON.parse(sessionStorage.getItem('usuario'));
  let token=null;
  if (user != null) {
    token = user.token;
  }

  return fetch(url_api + "/GetUsuarios", {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      'Authorization': `Bearer ${token}`
    },
    mode: 'cors'
  });
}


//----funcion para obtener todos los usuarios
export async function GetUsuariosPermisosApi(cui) {
  // let usuarioActual = await JSON.parse(sessionStorage.getItem("usuarioActual"));
  // console.log("llamando a perfil usuario api")
  let user = await JSON.parse(sessionStorage.getItem('usuario'));
  let token=null;
  if (user != null) {
    token = user.token;
  }

  return fetch(url_api + "/GetUsuariosPermisos", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      'Authorization': `Bearer ${token}`
    },
    mode: 'cors',
    body: JSON.stringify({
      cui: cui

    }),
  });
}


//----funcion para crear un usuario
export async function CrearUsuarioApi(
  cui, nombre, correo, password, iddepartamento, iddireccion, idpuesto, idunidad, idregion, idsubregion, idgerencia, idubicacion, idrol, activo,
  NoLicencia,TipoLicencia,FechaVenceLicencia,PermisoSolicitudEspecial,CuiJefe,SegundaLicencia = "",TipoSegundaLicencia = "",FechaVenceSegundaLicencia = ""
) {
  //console.log("si estoy entrando a crear")
  let user = await JSON.parse(sessionStorage.getItem('usuario'));
  let token=null;
  if (user != null) {
    token = user.token;
  }

  return fetch(url_api + "/CrearUsuario", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
       'Authorization': `Bearer ${token}`
    },
    mode: 'cors',
    body: JSON.stringify({
      cui: cui,
      nombre: nombre,
      correo: correo,
      password: password,
      iddepartamento: iddepartamento,
      iddireccion: iddireccion,
      idpuesto: idpuesto,
      idunidad: idunidad,
      idregion: idregion,
      idsubregion: idsubregion,
      idgerencia: idgerencia,
      idubicacion: idubicacion,
      idrol: idrol,
      activo: activo,
  //nuevos parametros
      NoLicencia: NoLicencia,
      TipoLicencia:TipoLicencia,
      FechaVenceLicencia: FechaVenceLicencia,
      PermisoSolicitudEspecial: PermisoSolicitudEspecial,
      CuiJefe:CuiJefe,
      SegundaLicencia: SegundaLicencia,
      TipoSegundaLicencia: TipoSegundaLicencia,
      FechaVenceSegundaLicencia: FechaVenceSegundaLicencia,

    }),
  });
};




//----funcion para editar un usuario
export async function ModificarUsuarioApi(
  cui, nombre, correo, password, iddepartamento, iddireccion, idpuesto, idunidad, idregion, idsubregion, idgerencia, idubicacion, idrol, activo,
  NoLicencia,TipoLicencia,FechaVenceLicencia,PermisoSolicitudEspecial,CuiJefe,SegundaLicencia = "",TipoSegundaLicencia = "",FechaVenceSegundaLicencia = ""
) {
  // console.log("si estoy entrando a modificar")
  let user = await JSON.parse(sessionStorage.getItem('usuario'));
  let token=null;
  if (user != null) {
    token = user.token;
  }

  return fetch(url_api + "/ModificarUsuario/" + cui, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      'Authorization': `Bearer ${token}`
    },
    mode: 'cors',
    body: JSON.stringify({
      cui: cui,
      nombre: nombre,
      correo: correo,
      password: password,
      iddepartamento: iddepartamento,
      iddireccion: iddireccion,
      idpuesto: idpuesto,
      idunidad: idunidad,
      idregion: idregion,
      idsubregion: idsubregion,
      idgerencia: idgerencia,
      idubicacion: idubicacion,
      idrol: idrol,
      //nuevos parametros
      NoLicencia: NoLicencia,
      TipoLicencia:TipoLicencia,
      FechaVenceLicencia: FechaVenceLicencia,
      PermisoSolicitudEspecial: PermisoSolicitudEspecial,
      CuiJefe:CuiJefe,
      SegundaLicencia: SegundaLicencia,
      TipoSegundaLicencia: TipoSegundaLicencia,
      FechaVenceSegundaLicencia: FechaVenceSegundaLicencia,

      activo: activo

    }),
  });
};



//----funcion para editar un usuario
export async function CambiarEstadoApi(
  cui
) {
  let user = await JSON.parse(sessionStorage.getItem('usuario'));
  let token=null;
  if (user != null) {
    token = user.token;
  }


  return fetch(url_api + "/CambiarEstadoUsuario/" + cui, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      'Authorization': `Bearer ${token}`
    },
    mode: 'cors'
  });
};


//----funcion para subir archivo excel


export async function CargamasivaUsuariosApi(
  file
) {
  let user = await JSON.parse(sessionStorage.getItem('usuario'));
  let token=null;
  if (user != null) {
    token = user.token;
  }


  return fetch(url_api + "/Cargamasivausuarios", {
    method: "POST",
    headers: {
      'Authorization': `Bearer ${token}`
    },
    mode: 'cors',
    body: file
  });
};


//----funcion para editar un usuario
export async function CambiarPasswordApi(
  cui,password
) {
  let user = await JSON.parse(sessionStorage.getItem('usuario'));
  let token=null;
  if (user != null) {
    token = user.token;
  }


  return fetch(url_api + "/CambiarPassword/" + cui, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      'Authorization': `Bearer ${token}`
    },
    mode: 'cors',
    body: JSON.stringify({
     password: password
    }),
  });
};
